import { useState } from "react";
import { EDIT_TAB_ONGOING } from "../constants/display";

const useAppState = () => {
  const initialStatePolicyDetail = {
    policyNumber: "",
    email: "",
    mobile: "",
    planType: "",
    planGroup: "",
    effectiveDate: new Date(),
    totalTraveller: 0,
    remainingTrips: 1,
    expiryDate: new Date(),
    travellerNames: [],
    nricPassport: "",
    area: null,
    registeredFlights: [],
  };
  const [policyDetail, setPolicyDetail] = useState(initialStatePolicyDetail);
  const [flightRegistrations, setFlightRegistrations] = useState([]);
  const [totalFlights, setTotalFlights] = useState(2);
  const [registrationStatus, setRegistrationStatus] = useState(null);
  const [isDeclarationChk, setIsDeclarationChk] = useState(false);
  const [isEditDeclarationChk, setIsEditDeclarationChk] = useState(false);
  const [navigationInfo, setNavigationInfo] = useState({
    backEditPage: false,
    isEditing: false,
  });
  const [editTab, setEditTab] = useState(EDIT_TAB_ONGOING);
  const [showMaintenance, setShowMaintenance] = useState({
    title: "",
    message: "",
  });

  return {
    initialStatePolicyDetail,
    policyDetail,
    setPolicyDetail,
    flightRegistrations,
    setFlightRegistrations,
    totalFlights,
    setTotalFlights,
    registrationStatus,
    setRegistrationStatus,
    isDeclarationChk,
    setIsDeclarationChk,
    isEditDeclarationChk,
    setIsEditDeclarationChk,
    editTab,
    setEditTab,
    navigationInfo,
    setNavigationInfo,
    showMaintenance,
    setShowMaintenance,
  };
};
export default useAppState;
